// paper props style for menu.
const paperProps = {
    elevation: 0,
    sx: {
        width: '290px',
        maxHeight: '80vh',
        // filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        boxShadow: 'rgb(0 0 0 / 15%) 0px 2px 8px',
        mt: 0.5,
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        '& .MuiMenuItem-root': {
            padding: '8px 16px',
            minHeight: '45px'
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
};

export default paperProps;
